import numberValue from '../../../../../../../../_dev/frontend/js/freeElements/numberValue';
import formatNumber from '../../../../../../../../_dev/frontend/js/commonFunctions/formatNumber';

const productPageChangePriceFromOption = () => {
    const priceContainer = document.querySelector('.Product-page__current-price');
    if (priceContainer) {
        const rawPrice = Number(priceContainer.dataset.rawPrice) || 0;
        const colorSelect = document.getElementById('select_in_input-option-256');
        if (colorSelect) {
            const changePrice = () => {
                let priceContainerEl = priceContainer.querySelector('span');
                let selectedOption = colorSelect.options[colorSelect.selectedIndex];
                let optionPrice = Number(selectedOption.getAttribute("data-price")) || 0;
                priceContainerEl.innerText = formatNumber(rawPrice + optionPrice);
                console.log(`raw-price: ${rawPrice}; option-price: ${optionPrice}`);
            }
            changePrice();
            colorSelect.addEventListener('change', () => changePrice());
        }
    }
}

export default productPageChangePriceFromOption;
